import React, {useState, useEffect, FC} from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import tracking from "@irati-tracking/perks/perks"

import {ButtonLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {DealExternalLinks} from "@irati/types"
import {Voucher} from "@irati/deals/types"
import Flex from "@irati/ui/src/Flex"
import {Loader} from "./styled/Loader"

interface Props {
  onCopy: () => void
  voucher: Voucher
  externalLinks: DealExternalLinks
}

const DealSuccessTicketActionButton: FC<Props> = ({voucher, onCopy, externalLinks}) => {
  const ONE_SECOND_IN_MILLISECONDS = 1000
  const COUNTDOWN_INITIAL_VALUE = 5
  const affiliateLink = React.createRef()

  const [counter, setCounter] = useState(COUNTDOWN_INITIAL_VALUE)
  const [trackFn, setTrackFn] = useState(tracking.visitRedirectCouponSite)
  const [click, setClick] = useState(0)

  useEffect(() => {
    copyVoucherCode()
  }, [])

  useEffect(() => {
    if (counter === 0) {
      affiliateLink.current.click()
      setClick(1)
      return trackFn
    } else {
      setTimeout(() => setCounter(counter - 1), ONE_SECOND_IN_MILLISECONDS)
    }
  }, [counter])

  const clickCouponSite = () => {
    if (click === 1) {
      setTrackFn(tracking.clickCouponSite)
    }
  }

  /** @author: Raul Hossu
   *  @desc: To test that copyVoucherCode is copying the code after loading, the focus should be on the window.
   *  Don't try to test it with an open console
   */
  const copyVoucherCode = async () => {
    try {
      await navigator.clipboard.writeText(voucher.code)
    } catch (err) {
      console.error("Failed to copy: ", err)
    }
  }

  return (
    <CopyToClipboard text={voucher.code} onCopy={onCopy}>
      {counter > 0 ? (
        <Flex direction="column" alignItems="center">
          <Loader />
          <FormattedMessage id="perks.components.tickets.ticket.openRetailerWebsite" />
        </Flex>
      ) : (
        <>
          <ButtonLink ref={affiliateLink} primary full href={externalLinks.web} target="_blank" onClick={clickCouponSite}>
            <FormattedMessage id="perks.components.tickets.ticket.visitSite" />
          </ButtonLink>
        </>
      )}
    </CopyToClipboard>
  )
}

export default DealSuccessTicketActionButton
